import React from 'react'
import styles from './Button.module.scss'

const Button = () => {
  const scrollToContact = () => {
    const contactSection = document.querySelector('#contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div>
      <div id="container">
        <button className={styles.learn_more} onClick={scrollToContact}>
          <span className={styles.circle} aria-hidden="true">
            <span className={`${styles.icon} ${styles.arrow}`}></span>
          </span>
          <span className={styles.button_text}>Let's Connect</span>
        </button>
      </div>

    </div>

  )
}

export default Button